import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';

@Injectable({
    providedIn: 'root',
})
export class AuthSubscriptionService {
    public guid: string;
    private authChangeSub = new BehaviorSubject<boolean>(false);
    public authChanged = this.authChangeSub.asObservable();

    constructor() {
        this.guid = uuidv4();
    }

    public sendAuthStateChangeNotification = (isAuthenticated: boolean) => {
        this.authChangeSub.next(isAuthenticated);
    };
}
